<template>
    <div data-click="no">
        <a v-if="create_sf" class="button_with_without_text vue_show_tooltip" @click="call" data-click="no">
            <svg v-show="!saved"  width="17" height="8" viewBox="0 0 17 8" fill="none" xmlns="http://www.w3.org/2000/svg" data-click="no">
                <path d="M17.0001 8C17.0001 8 12.3825 0 5.93307 0C-0.554486 0 -0.344594 8 4.6928 8C9.7302 8 17.0001 8 17.0001 8Z" fill="#F2C300" data-click="no"/>
                <path d="M14.9965 8C14.9965 8 10.9513 0.98877 5.31283 0.98877C-0.363784 0.98877 -0.182515 8 4.22521 8C8.63293 8 14.9965 8 14.9965 8Z" fill="#D428D5" data-click="no"/>
                <path d="M12.8976 8.00009C12.8976 8.00009 9.46302 2.0675 4.6546 2.0675C-0.172903 2.0675 -0.0202542 8.00009 3.72917 8.00009C7.48814 8.00009 12.8976 8.00009 12.8976 8.00009Z" fill="#00B1FC" data-click="no"/>
            </svg>
            <div  v-show="saved" class="spin"></div>
            <tool-tip class="vue_tooltip hide" side="r" text="Kopírovať ponuku do aplikácie SuperFaktura.sk"/>
        </a>
        <a v-else href="/admin/nastavenia/superfaktura" class="button_with_without_text vue_show_tooltip" data-click="no">
            <svg width="17" height="8" viewBox="0 0 17 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.0001 8C17.0001 8 12.3825 0 5.93307 0C-0.554486 0 -0.344594 8 4.6928 8C9.7302 8 17.0001 8 17.0001 8Z" fill="#F2C300"/>
                <path d="M14.9965 8C14.9965 8 10.9513 0.98877 5.31283 0.98877C-0.363784 0.98877 -0.182515 8 4.22521 8C8.63293 8 14.9965 8 14.9965 8Z" fill="#D428D5"/>
                <path d="M12.8976 8.00009C12.8976 8.00009 9.46302 2.0675 4.6546 2.0675C-0.172903 2.0675 -0.0202542 8.00009 3.72917 8.00009C7.48814 8.00009 12.8976 8.00009 12.8976 8.00009Z" fill="#00B1FC"/>
            </svg>
            <tool-tip class="vue_tooltip hide" side="r" text="Prepojenie na superfaktúru - potrebné vyplniť API kľúč v nastaveniach integrácií."/>
        </a>
        <div v-if="success_add" data-growl="container" class="alert alert-success background-success alert-dismissable animated " v-bind:class="{ bounceInLeft: success_add,  bounceOutRight: !success_add}" role="alert" data-growl-position="top-right" style="position: fixed; margin: 0px; z-index: 999999; display: inline-block; top: 30px; right: 30px; width: auto; background-color: #4caf50;color: #fff;" data-click="no">
            <button type="button" class="close" data-growl="dismiss" style="display: block; z-index: 999998;" data-click="no">
                <span @click="success_add = false" aria-hidden="true" data-click="no">×</span>
            </button>
            <span data-growl="title" data-click="no" style="font-family: 'Lato', Helvetica, 'Roboto', Arial, sans-serif; font-size:15px;">   
                Ponuka bola úspešne skopírovana do aplikácie SuperFaktura.sk. <br>
                <a id="url_copy" href="https://moja.superfaktura.sk/invoices/index/type:proforma"
                target="_blank" style="color: white;" data-click="no">Prejsť na faktúry</a>
            </span>
        </div>
    </div>
</template>

<script>
import ToolTip from '../../vue_components/ToolTip.vue';
export default {
    props: ['offer_id', 'create_sf'],
    components: {ToolTip},
    data() {
        return {
            saved:false,
            success_add: false,
        }
    },
    methods: {
        call() {
            this.saved = true
            axios.post(`/api/superfaktura`, {offer_id:this.offer_id} )
            .then(response => { 
                this.saved = false
                this.success_add = true
                //this.$toast.success("Ponuka bola úspešne skopírovana do Super Faktúry.", {timeout: 3038});
                setTimeout(() => this.success_add = false , 5000);
             }).catch(function (error) { 
                this.saved = false
                this.$toast.error("Ponuku sa nepodarilo skopírovať do Super Faktúry.", {timeout: 3038});
              });
        }
    },
    mounted () {
        $( ".tooltip_hover" ).hover(
            function() {
                $( this ).parent().find('.my_tooltip').css('opacity', '1');
            },
            function() {
                $( this ).parent().find('.my_tooltip').css('opacity', '0');
            },
        );
    },
}
</script>

<style lang="scss" scoped>
#url_copy:hover{
    text-decoration: underline;
}
.vue_show_tooltip{
    position: relative;
}
.button_with_without_text{
    cursor: pointer;
    width: 28px;
    height: 28px;
    padding: 2px 2px;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 24px;
    background: #F3F4F6;
    &.disabled{
        background: #f3f4f681;
        span{
            color: #9ca3af75;
        }
        &:hover{
            background: #f3f4f681;
            cursor: no-drop;
        }
        svg{
            path{
                stroke: none !important;
            }
        }
    }
    span{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 10px;
        line-height: 12px;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        margin-left: 7px;
        color: #9CA3AF;
    }
    &:hover{
        transition: all .3s;
        background: #e2e2e2;
    }
    &.clicked{
        background: #ECFDF5;
        span{
            color: #34D399;
        }
        svg{
            path{
                stroke:#34D399;
            }
        }
        &:hover{
            transition: all .3s;
            background: #cfffe8;
        }
    }
    svg{
        path{
            stroke:transparent;
        }
    }
}
 @keyframes spinner {
    0% {
        transform: translate3d(-50%, -50%, 0) rotate(0deg);
    }
    100% {
        transform: translate3d(-50%, -50%, 0) rotate(360deg);
    }
}
.spin::before {
    animation: 1.5s linear infinite spinner;
    animation-play-state: inherit;
    border: solid 2px #9CA3AF;
    border-bottom-color: #1c87c9;
    border-radius: 50%;
    content: "";
    height: 15px;
    width: 15px;
    position: absolute;
    top: 14px;
    left: 14px;
    transform: translate3d(-50%, -50%, 0);
    will-change: transform;
}

</style>